<template>
  <div class="upgrade-check">
    <div class="statistics">
      <el-row class="row">
        <el-col :span="2">
          总题数：
        </el-col>
        <el-col :span="22">
          {{ questions.length }} 题
        </el-col>
      </el-row>

      <el-row class="row">
        <el-col :span="2">
          能力版块维度：
        </el-col>
        <el-col :span="22">
          <div>&nbsp;</div>
          <div
            v-for="(value, key) in questionBoardMap"
            :key="key"
          >
            {{ key }}: {{ value }} 题
          </div>
        </el-col>
      </el-row>

      <el-row class="row">
        <el-col :span="2">
          知识版块维度：
        </el-col>
        <el-col :span="22">
          <div>&nbsp;</div>
          <div
            v-for="(value, key) in questionRrainingMap"
            :key="key"
          >
            {{ key }}: {{ value }} 题
          </div>
        </el-col>
      </el-row>

      <div class="preview">
        <span class="iconfont icon-iphone">：</span>
        <qrcode
          v-if="mobilePreviewUrl"
          :width="100"
          :height="100"
          :text="mobilePreviewUrl"
        />
        <span class="iconfont icon-ipad">：</span>
        <qrcode
          v-if="padPreviewUrl"
          :width="100"
          :height="100"
          :text="padPreviewUrl"
        />
      </div>
    </div>

    <div class="operate">
      <el-button
        type="primary"
        size="small"
        @click="checking('resolved')"
      >
        {{ $t("通过") }}
      </el-button>
      <el-button
        size="small"
        @click="rejected()"
      >
        {{ $t("驳回") }}
      </el-button>
      <el-button
        type="success"
        size="small"
        @click="publish"
      >
        {{ $t("发布") }}
      </el-button>
      <el-button
        size="small"
        @click="back"
      >
        {{ $t("取消") }}
      </el-button>
    </div>

    <div class="questions">
      <el-table
        :data="questions"
        style="width: 100%;"
      >
        <el-table-column
          label="序号"
          width="80"
          type="index"
        />

        <el-table-column
          label="题型"
          width="150"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.type | questionType }}</span>
          </template>
        </el-table-column>

        <el-table-column label="内容梗概(文本、图片、音频等)">
          <template slot-scope="scope">
            <question-content
              :key="scope.row.uuid"
              :question="scope.row"
            />
          </template>
        </el-table-column>

        <el-table-column
          label="知识点"
          width="250"
        >
          <template slot-scope="scope">
            <question-point
              :key="scope.row.uuid"
              :question="scope.row"
            />
          </template>
        </el-table-column>

        <el-table-column
          label="答案"
          width="90"
        >
          <template slot-scope="scope">
            <question-answer
              :key="scope.row.uuid"
              :question="scope.row"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :visible.sync="rejectedDialogVisible"
      width="40%"
    >
      <el-form label-width="80px">
        <el-form-item label="审核建议">
          <el-input
            v-model="checkingMessage"
            type="textarea"
            :rows="4"
          />
        </el-form-item>
      </el-form>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="small"
          @click="rejectedDialogVisible = false"
        >取 消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="checking('rejected')"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style lang="less" scoped>
.upgrade-check {
  .statistics {
    position: relative;
    .row {
      color: #606266;
      padding: 0 12px 0 0;
      line-height: 32px;
    }

    .preview {
      display: flex;
      position: absolute;
      right: 200px;
      top: 20px;
      width: 100px;
      height: 100px;
    }
  }
  .operate {
    margin-top: 10px;
  }
  .questions {
    margin-top: 20px;
  }
}
</style>

<script>
const debug = require('debug')('ccs:ctrl:upgrade-edit');

import questionContent from '../components/question_content';
import questionAnswer from '../components/question_answer';
import questionPoint from '../components/question_point';
import qrcode from '../components/qrcode';
import { findIndex, pick } from 'lodash';
import { questionParse } from '../utils';
import axios from 'axios';

export default {
	components: {
		questionContent,
		questionAnswer,
		questionPoint,
		qrcode
	},
	data() {
		return {
			rejectedDialogVisible: false,
			checkingMessage: '',

			//   数据
			levelId: null,
			version: null,
			mobilePreviewUrl: null,
			padPreviewUrl: null,
			questions: [],
			standard: null,
		};
	},
	computed: {
		// 能力版块
		questionBoardMap: function() {
			return this.questions.reduce((count, { board }) => {
				if (!board) return count;

				if (count[board]) {
					count[board]++;
				} else {
					count[board] = 1;
				}
				return count;
			}, {});
		},
		// 知识版块
		questionRrainingMap: function() {
			return this.questions.reduce((count, { training }) => {
				if (!training) return count;

				if (count[training]) {
					count[training]++;
				} else {
					count[training] = 1;
				}
				return count;
			}, {});
		}
	},
	async created() {
		await this.init();
	},
	methods: {
		async init() {
			const { levelId } = this.$route.params;
			const { version, standard } = this.$route.query;
			const [questions, urls] = await Promise.all([
				axios.get(`/api/up/${levelId}/questions`, {
					params: { version, standard }
				}),
				axios.get(`/api/up/${levelId}/urls`, {
					params: { version, standard }
				})
			]);

			debug('[init] levelId: %s, version: %s', levelId, version);

			this.levelId = levelId;
			this.version = version;
			this.questions = questions.map(
				({ question }) => questionParse(question)[0]
			);
			this.mobilePreviewUrl = urls.mobile.split('?') ? urls.mobile.split('?')[0] : '';
			this.mobilePreviewUrl = `${this.mobilePreviewUrl}?preview=true`;
			this.padPreviewUrl = urls.mobile.split('?') ? urls.pad.split('?')[0] : '';
			this.padPreviewUrl = `${this.padPreviewUrl}?preview=true`;
			this.standard = standard;
		},

		async rejected() {
			this.rejectedDialogVisible = true;
			this.checkingMessage = '';
		},

		// 审校
		async checking(checkingStatus) {
			if (this.checkingMessage.length > 300) {
				this.$message({
					showClose: true,
					message: '审核建议最多300个字符。',
					type: 'error'
				});
				return;
			}
			this.rejectedDialogVisible = false;

			await axios.put(`/api/up/${this.levelId}/checking`, {
				version: this.version,
				checkingStatus,
				checkingMessage: this.checkingMessage,
				standard: this.standard
			});

			this.back();
		},

		// 题发布
		async publish(version) {
			await axios.put(`/api/up/${this.levelId}/checking`, {
				version: this.version,
				checkingStatus: 'resolved',
				standard: this.standard
			});
			await axios.post(`/api/up/${this.levelId}/publish`, {
				version: this.version,
				standard: this.standard
			});
			this.back();
		},

		back() {
			this.$router.replace({
				name: 'upgrade',
				query: { levelId: this.levelId }
			});
		}
	}
};
</script>
